import moment from 'moment'

export const passwordRequirements = [
    {
        label: 'Mínimo de 8 e máximo de 20 caracteres.',
        isValid: (password) => {
            if (!password) return null

            return password.length >= 8 && password.length <= 20
        },
    },
    {
        label: 'No mínimo uma letra.',
        isValid: (password) => {
            if (!password) return null

            return /[a-zA-Z]/.test(password)
        },
    },
    {
        label: 'No mínimo um número.',
        isValid: (password) => {
            if (!password) return null

            return /\d/.test(password)
        },
    },
    {
        label: 'No mínimo 1 caractere especial.',
        isValid: (password) => {
            if (!password) return null

            return /[!@#$%^&*(),.?":{}|<>]/.test(password)
        },
    },
    {
        label: 'Não deve conter mais de 3 números repetidos em ordem.',
        isValid: (password) => {
            if (!password) return null

            return !/(\d)\1{3,}/.test(password)
        },
    },
    {
        label: 'Não deve conter mais de 3 números sequenciais.',
        isValid: (password) => {
            if (!password) return null

            const digits = password.replace(/\D/g, '')
            let sequentialCount = 1
            for (let i = 0; i < digits.length - 1; i++) {
                if (parseInt(digits[i]) + 1 === parseInt(digits[i + 1])) {
                    sequentialCount++
                    if (sequentialCount > 3) return false
                } else {
                    sequentialCount = 1
                }
            }
            return true
        },
    },
    {
        label: 'Ser diferente do CPF, data de nascimento, celular ou e-mail.',
        isValid: (
            password,
            userData = {
                cpf: '',
                dateOfBirth: '',
                phoneNumber2: '',
                email: '',
            },
        ) => {
            if (!password) return null

            const normalize = (value) =>
                value.replace(/[\s\/().-]/g, '').toLowerCase()

            const checks = []

            if (userData.cpf) checks.push(normalize(userData.cpf))

            if (userData.dateOfBirth) {
                const dob = userData.dateOfBirth
                checks.push(normalize(dob))
                checks.push(moment(dob).format('MMDDYY'))
                checks.push(moment(dob).format('YYYYMMDD'))
            }

            if (userData.phoneNumber2)
                checks.push(normalize(userData.phoneNumber2))

            if (userData.email) checks.push(userData.email.toLowerCase())

            const normalizedPassword = normalize(password)

            for (const item of checks) {
                if (
                    item &&
                    item.length > 0 &&
                    normalizedPassword.includes(item)
                ) {
                    return false
                }
            }

            return true
        },
    },
]

export function countValidRequirements(password, userData) {
    return passwordRequirements.reduce((acc, requirement) => {
        return requirement.isValid(password, userData) ? acc + 1 : acc
    }, 0)
}

export function getPasswordStrength(password, userData) {
    const validCount = countValidRequirements(password, userData)

    if (validCount <= 2) return 1
    if (validCount <= 3) return 2
    if (validCount <= 5) return 3
    if (validCount === 6) return 4

    return 5
}
